import {
  GET_LOST_COUPONS_REQUEST,
  GET_LOST_COUPONS_SUCCESS,
  GET_LOST_COUPONS_FAILURE,
  RESET_LOST_COUPONS_PAGINATION
} from 'Store/constants';

const initialState = {
  data: [],
  pagination: {
    pageSize: 15,
    pageIndex: 0,
    hasMore: null
  },
  isFetched: false,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LOST_COUPONS_REQUEST:
      return { ...state, isFetched: false, isLoading: true, error: null };
    case GET_LOST_COUPONS_SUCCESS: {

      if (action.couponDetail) {
        state.data.map(coupon => {
          if (coupon.couponId === action.couponDetail.couponId) {
            return coupon['selections'] = action.couponDetail['couponColumns'];
          }
          return coupon;
        });
      }

      return {
        data: [...state.data, ...action.payload],
        pagination: {
          ...action.pagination,
          hasMore: true
        },
        isFetched: true,
        isLoading: false,
        error: null
      };
    }
    case GET_LOST_COUPONS_FAILURE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          hasMore: false
        },
        isFetched: true,
        isLoading: false,
        error: action.payload
      };
    case RESET_LOST_COUPONS_PAGINATION:
      return { ...state, pagination: initialState.pagination, data: [] };
    default:
      return state;
  }
};
